import React from 'react';
import { DatoCmsLink, DatoCmsNumberedListItem } from '../../../schema/datocms/blocks';
import { getBrandClassFromHex } from '../../../utilities/brand-color';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import Link from '../../link/link';

// display index starts at 1 instead of 0
const NumberedListItemComponent = ({ item, displayIndex }: { item: DatoCmsNumberedListItem, displayIndex: number}): React.ReactElement => {
    const link: DatoCmsLink | undefined = item?.links && item.links.length > 0 ? item.links[0] : undefined;

    let backgroundClass: string = link ? 'link-with-background' : 'bg-theme-overlay';
    if (item?.colorOverride) {
        backgroundClass = `bg-${getBrandClassFromHex(item.colorOverride.hex)}`;
    }

    const numberedItem = (
        <div className="flex flex-col items-center space-y-8">
            <div className={`${backgroundClass} text-theme-overlay-text h-24 w-24 rounded-full flex flex-col justify-center items-center`}>
                <div className="font-serif font-semibold text-4xl">{displayIndex}</div>
            </div>

            <h3 className="text-center">

                { (item.text && <HtmlEntityTextComponent text={item.text} />) || item.text }

            </h3>
        </div>
    );

    if (link) {
        return (
            <Link
                internalPageReference={link.internalPageReference}
                internalPageSectionId={link.internalSectionComponentId}
                externalPageUrl={link.externalPageUrl}
            >{numberedItem}</Link>
        );
    }

    return numberedItem;
};

export default NumberedListItemComponent;
